import { render, staticRenderFns } from "./PreferredVendorTag.vue?vue&type=template&id=19da34e8&scoped=true&"
import script from "./PreferredVendorTag.vue?vue&type=script&lang=js&"
export * from "./PreferredVendorTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da34e8",
  null
  
)

export default component.exports